import { render, staticRenderFns } from "./Flyers.vue?vue&type=template&id=7d21f57a&scoped=true"
import script from "./Flyers.vue?vue&type=script&lang=js"
export * from "./Flyers.vue?vue&type=script&lang=js"
import style0 from "./Flyers.vue?vue&type=style&index=0&id=7d21f57a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d21f57a",
  null
  
)

export default component.exports